<template>
  <div class="h-artifact h-outer-border around-4 bw2 bz0 h-bg brown-2" :style="sizeStyle">
    <template v-if="artifact">
      <div class="icon-wrapper h-effect"
           :class="['quality-' + artifact.quality, isEquipment ? 'equipment' : '']">
        <img class="artifact-icon" :src="cargoUrl(artifact.sourceName)" alt="">
        <div v-if="isMountSkin(artifact)" class="effectDay-day">{{ getEffectDay(artifact) }} 天</div>
        <div v-if="artifact.slot === 9 && artifact.level > 0"
             class="treasure-star">
          <img class="icon-treasure-star"
               :src="`${$rHost}/img/common/icon_treasure_lv_${artifact.level}.png`"
               alt="">
        </div>
      </div>
      <HArtifactInfoBox :artifact-info="artifact" :show-use-help="false"></HArtifactInfoBox>
    </template>
  </div>
</template>

<script>
  import HArtifactInfoBox from '@/components/h-artifact-info-box'

  export default {
    name: 'index',

    props: {
      artifact: {
        type: Object,
        default () {
          return {}
        }
      },

      size: {
        type: Number,
        default: 55,
      }
    },

    computed: {
      isEquipment () {
        return this.artifact?.artifactId > 1000 && this.artifact?.artifactId < 3000
      },

      sizeStyle () {
        return `width: ${this.size}px; height: ${this.size}px;`
      },
    },

    methods: {
      cargoUrl (sourceName) {
        return `${this.$rHost}/img/artifact/${sourceName}`
      },

      isMountSkin (item) {
        return /时效坐骑/.test(item.nameCn)
      },

      getEffectDay (item) {
        const effectDayItem = item.effect?.find((d) => d.attr === 'effectDay')
        return effectDayItem?.value || ''
      },
    },

    components: {
      HArtifactInfoBox,
    }
  }
</script>

<style lang="stylus" scoped>
  .h-artifact
    display flex
    align-items center
    justify-content center
    padding 3px
    z-index 2
    &:hover .h-artifact-info-box
      display block
    .icon-wrapper
      position relative
    .artifact-icon
      max-width 100%
      max-height 100%
      vertical-align top

  .effectDay-day
    position absolute
    z-index 1
    width 100%
    padding-right 2px
    left 0
    top 2px
    font-size 12px
    text-align right
    goldText1()
    opacity 0.9
    transform-origin right top
    transform scale(0.67, 0.67)

  .treasure-star
    position absolute
    z-index 2
    display flex
    align-items center
    justify-content center
    top 0
    right -2px
    height 12px
    .level-text
      line-height 12px
      font-size 12px
      font-weight bold
      color orange
      transform scale(0.833)
      text-shadow 0 0 1px #fff, 0 1px 1px #212121
    .icon-treasure-star
      width 20px
      height 10px
</style>
